/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
import {IIntercomSettings} from './intercom-settings.interface';

export const SESSION_DURATION_INTERCOM = 500;
export const MAIN_COLOR = '#2C9C74';
export const VERTICAL_PADDING_NON_AUTHENTICATED = 50;
export const PRODUCT_TYPE_INTERCOM = 'VDR';

export class IntercomSettings {
  public readonly app_id: string;
  public readonly session_duration: number;
  public readonly IP: string;
  public readonly background_color: string;
  public readonly action_color: string;
  public readonly vertical_padding: number;
  public readonly enabled: boolean;
  public readonly product_type: string;
  public readonly alignment?: 'right' | 'left';

  constructor({
                app_id,
                ip,
                enabled,
                background_color,
                action_color,
                session_duration,
                alignment,
              }: IIntercomSettings) {
    this.app_id = app_id;
    this.IP = ip;
    this.background_color = background_color || MAIN_COLOR;
    this.action_color = action_color || MAIN_COLOR;
    this.enabled = enabled;
    this.vertical_padding = VERTICAL_PADDING_NON_AUTHENTICATED;
    this.session_duration = session_duration || SESSION_DURATION_INTERCOM;
    this.product_type = PRODUCT_TYPE_INTERCOM;
    this.alignment = alignment;
  }
}
